import { Vue } from 'vue-class-component';
import LiveEventsTable from './live-events-table';
import TranscodingTable from './transcoding-table';

export default class PublicDashboard extends Vue {
  render() {
    return (
      <div>
        <LiveEventsTable />
        <br />
        <TranscodingTable />
      </div>
    );
  }
}
